import { GenericAction } from '../data-described/actions/generic-action.model';

export class TableAction extends GenericAction {

}
